import { configureStore, applyMiddleware } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import reducers from './Reducers';

export const store = configureStore({ reducer: reducers, middleWare: applyMiddleware(thunk)});
